{
  "landing.auth.sign_in_description": "מעבירים אותך לשער ההזדהות המאובטח של Tov+ ואז בחזרה לאירוע שלך.",
  "landing.auth.sign_in_title": "כניסת מתכננים",
  "landing.couples.connected_summary": "אירועי סוף השבוע, הלוגיסטיקה, פרטי המתנות ופעולות ה-RSVP נשארים מסונכרנים באותו אירוע.",
  "landing.couples.connected_title": "כל אירוע נשאר מחובר",
  "landing.couples.guest_experience_summary": "זוגות מקבלים אתר מלוטש לאורחים, כלי שיתוף פשוטים ופרטי אירוע ברורים בלי מורכבות שמיועדת רק למתכננים.",
  "landing.couples.guest_experience_title": "חוויה יפהפייה לאורחים",
  "landing.dashboard_activity.new_rsvp": "התקבלה תשובת RSVP חדשה",
  "landing.dashboard_activity.one_hour_ago": "לפני שעה",
  "landing.dashboard_activity.schedule_updated": "לוח הזמנים עודכן",
  "landing.dashboard_activity.ten_minutes_ago": "לפני 10 דקות",
  "landing.dashboard_activity.two_hours_ago": "לפני שעתיים",
  "landing.dashboard_activity.welcome_email_sent": "אימייל קבלת פנים נשלח",
  "landing.dashboard_events.engagement_date": "20 ביוני 2026",
  "landing.dashboard_events.engagement_name": "מסיבת אירוסין",
  "landing.dashboard_events.in_progress": "בתהליך",
  "landing.dashboard_events.planning": "בתכנון",
  "landing.dashboard_events.wedding_dates": "1-3 ביולי 2026",
  "landing.dashboard_events.wedding_name": "החתונה של זיו וזאבי",
  "landing.dashboard_nav.reports": "דוחות",
  "landing.dashboard_rsvp.accepted": "אישרו הגעה",
  "landing.dashboard_tasks.due_this_week": "לתאריך השבוע",
  "landing.docs_redirect.link_label": "מסמכי Tov+",
  "landing.docs_redirect.text": "מעבירים אל",
  "landing.docs_redirect.title": "מעבירים למסמכי Tov+",
  "landing.environment.local": "מקומי",
  "landing.environment.non_production": "לא ייצור",
  "landing.environment.staging": "סטייג׳ינג",
  "landing.environment.tag_label": "תג סביבת עבודה",
  "landing.features.communications_summary": "שלחו עדכונים ותזכורות מלוטשים שנשארים מסונכרנים עם התצוגה של כל אורח וספק.",
  "landing.features.event_planning_summary": "שמרו טקס, קבלת פנים, בראנץ׳, נסיעות ורגעים פרטיים מחוברים בציר זמן אחד.",
  "landing.features.event_planning_title": "תכנון אירועים",
  "landing.features.guest_management_summary": "ארגנו משקי בית, הזמנות ועדכוני RSVP בלי לאבד את התמונה המלאה של האירוע.",
  "landing.features.guest_management_title": "ניהול אורחים",
  "landing.features.guest_website_summary": "שתפו אתר אירוע מותאם אישית עם לוחות זמנים, פרטי נסיעה ופעולות חשובות בתוך דקות.",
  "landing.features.guest_website_title": "אתר אורחים",
  "landing.features.vendor_access_summary": "תנו לספקים לוחות זמנים, משימות, הערות והעלאות בהיקף המתאים בלי לחשוף מידע שמיועד רק למתכננים.",
  "landing.features.vendor_access_title": "גישה לספקים",
  "landing.filter_review.about.audience_label": "קהל מיועד",
  "landing.filter_review.about.not_intended_label": "לא מיועד ל",
  "landing.filter_review.about.organizer_intro": "הפלטפורמה מאפשרת למארגנים לנהל תכנון אירועים וגישה לאירוע מול אורחים בסביבת עבודה פרטית אחת.",
  "landing.filter_review.about.product_label": "מוצר",
  "landing.filter_review.about.product_value": "Tov+",
  "landing.filter_review.about.purpose": "טוב+ היא פלטפורמה פרטית לניהול אירועים המיועדת לחתונות, חגיגות משפחתיות, אירועים פרטיים ומתכנני אירועים מקצועיים.",
  "landing.filter_review.about.purpose_label": "מטרה",
  "landing.filter_review.audiences.businesses": "עסקים שמארחים אירועים",
  "landing.filter_review.audiences.couples": "זוגות",
  "landing.filter_review.audiences.event_planners": "מתכנני אירועים",
  "landing.filter_review.audiences.families": "משפחות",
  "landing.filter_review.audiences.private_organizers": "מארגני אירועים פרטיים",
  "landing.filter_review.authenticated_areas.billing": "חיוב",
  "landing.filter_review.authenticated_areas.dashboard": "לוח בקרה",
  "landing.filter_review.authenticated_areas.event_editing": "עריכת אירוע",
  "landing.filter_review.authenticated_areas.guest_management": "ניהול אורחים",
  "landing.filter_review.authenticated_areas.planner": "סביבת עבודה של מתכנן",
  "landing.filter_review.authenticated_areas.settings": "הגדרות",
  "landing.filter_review.authenticated_areas.vendor": "פורטל ספקים",
  "landing.filter_review.authentication.authenticated_label": "נדרש אימות",
  "landing.filter_review.authentication.public_label": "ציבורי",
  "landing.filter_review.contact.country_label": "ארץ הפעולה",
  "landing.filter_review.contact.country_value": "ארצות הברית",
  "landing.filter_review.contact.response_label": "זמן תגובה אופייני",
  "landing.filter_review.contact.response_value": "יום עד שני ימי עסקים לפניות ספקי ביקורת.",
  "landing.filter_review.contact.security_label": "אימייל אבטחה",
  "landing.filter_review.contact.support_label": "דוא\"ל תמיכה",
  "landing.filter_review.contact.website_label": "אתר החברה",
  "landing.filter_review.content_policy.body": "טוב+ מארח תוכן פרטי לניהול אירועים. תוכן אופייני הוא מידע מעשי הדרוש לתכנון או השתתפות באירוע.",
  "landing.filter_review.content_types.contact_information": "פרטי התקשרות",
  "landing.filter_review.content_types.family_invitations": "הזמנות לאירועים משפחתיים",
  "landing.filter_review.content_types.guest_lists": "רשימות אורחים",
  "landing.filter_review.content_types.invitation_designs": "עיצובי הזמנות",
  "landing.filter_review.content_types.maps": "מפות ופרטי מיקום",
  "landing.filter_review.content_types.mitzvah_invitations": "הזמנות לבר ובת מצווה",
  "landing.filter_review.content_types.pdfs": "קובצי PDF",
  "landing.filter_review.content_types.schedules": "לוחות זמנים לאירועים",
  "landing.filter_review.content_types.seating": "סידורי ישיבה",
  "landing.filter_review.content_types.wedding_invitations": "הזמנות לחתונה",
  "landing.filter_review.demo.body": "אישורי הדגמה ציבוריים קבועים אינם מתפרסמים בדף זה. סוקרי סינון אינטרנט עשויים לבקש חשבון הדגמה או סביבת סקירה מודרכת על ידי פנייה לתמיכה. אם נדרשת התחברות, טוב+ תספק את גישת הסוקרים המתאימה ישירות.",
  "landing.filter_review.domain_purposes.admin": "ניהול פנימי של הפלטפורמה.",
  "landing.filter_review.domain_purposes.api": "נקודות קצה של API בייצור המשמשות את אפליקציות Tov+.",
  "landing.filter_review.domain_purposes.docs": "תיעוד ציבורי.",
  "landing.filter_review.domain_purposes.guest": "חוויות הזמנה ו-RSVP לאורחים.",
  "landing.filter_review.domain_purposes.marketing": "אתר ציבורי לשיווק, משפטי, תיעוד ומרכז סקירה זה.",
  "landing.filter_review.domain_purposes.planner": "לוח בקרה מאומת למתכננים ותפעול אירועים.",
  "landing.filter_review.domain_purposes.realtime": "עדכוני הודעות בזמן אמת וסטטוס התראות.",
  "landing.filter_review.domain_purposes.vendor": "פורטל ספקים מאומת.",
  "landing.filter_review.domain_purposes.wildcard": "דומיינים להזמנות אורחים לפי אירוע.",
  "landing.filter_review.faq.ads.answer": "אף פרסום של צד שלישי אינו חלק מחוויית הליבה של המוצר.",
  "landing.filter_review.faq.ads.question": "האם הפלטפורמה מכילה פרסום של צד שלישי?",
  "landing.filter_review.faq.adult.answer": "שום תוכן למבוגרים אינו מיועד או מותר כחלק משימוש רגיל בפלטפורמה.",
  "landing.filter_review.faq.adult.question": "האם הפלטפורמה מכילה תוכן למבוגרים?",
  "landing.filter_review.faq.browse.answer": "לא. טוב+ לא מספקת ספריית הזמנות פומבית.",
  "landing.filter_review.faq.browse.question": "כל אחד יכול לעיין בהזמנות?",
  "landing.filter_review.faq.dating.answer": "מס' טוב+ היא פלטפורמה לניהול אירועים לאירועים פרטיים.",
  "landing.filter_review.faq.dating.question": "האם זו פלטפורמת היכרויות?",
  "landing.filter_review.faq.forum.answer": "לא. טוב+ אינו מפעיל פורום ציבורי.",
  "landing.filter_review.faq.forum.question": "יש פורום דיונים?",
  "landing.filter_review.faq.guest_uploads.answer": "העלאות אורחים אינן חלק מהזמנת אורח וזרימת RSVP הבסיסית, אלא אם תכונת אירוע ספציפית מאפשרת נתיב העלאה מבוקר.",
  "landing.filter_review.faq.guest_uploads.question": "האם אורחים יכולים להעלות תוכן?",
  "landing.filter_review.faq.indexing.answer": "דפי הזמנות מיועדים לגישה משותפת לקישורים, לא לאינדקס של ספריות ציבוריות.",
  "landing.filter_review.faq.indexing.question": "האם הזמנות אינדקס על ידי מנועי החיפוש?",
  "landing.filter_review.faq.public_communication.answer": "לא מסופק עדכון חברתי ציבורי או ערוץ תקשורת ציבורי.",
  "landing.filter_review.faq.public_communication.question": "האם משתמשים יכולים לתקשר בפומבי?",
  "landing.filter_review.faq.upload_visibility.answer": "לא. היקפים של קבצים שהועלו הם בעלי האירוע ומשתתפי האירוע המורשים.",
  "landing.filter_review.faq.upload_visibility.question": "האם קבצים שהועלו הם ציבוריים?",
  "landing.filter_review.faq.uploads.answer": "כֵּן. מארגנים מורשים יכולים להעלות תמונות, קובצי PDF, לוגו ומסמכים הקשורים לאירועים.",
  "landing.filter_review.faq.uploads.question": "האם משתמשים יכולים להעלות קבצים?",
  "landing.filter_review.faq.video.answer": "אירוח וידאו אינו תכונת ליבה של פלטפורמה. מסמכי אירוע ותמונות הם סוגי התוכן הצפויים שהועלו.",
  "landing.filter_review.faq.video.question": "האם הפלטפורמה מארחת סרטונים?",
  "landing.filter_review.features.check_in.summary": "כלי הגעת אורחים ונוכחות כאשר מופעלים עבור אירוע.",
  "landing.filter_review.features.check_in.title": "צ'ק אין",
  "landing.filter_review.features.digital_invitations.summary": "משלוח הזמנות דיגיטלי וקישורי גישה לאורחים בשליטת מארגן האירוע.",
  "landing.filter_review.features.digital_invitations.title": "הזמנות דיגיטליות",
  "landing.filter_review.features.email_notifications.summary": "הזמנה אופציונלית, תזכורת ומשלוח דוא\"ל תפעולי.",
  "landing.filter_review.features.email_notifications.title": "הודעות אימייל",
  "landing.filter_review.features.event_forms.summary": "טפסים פרטיים לאיסוף מידע ספציפי לאירוע כגון בחירת ארוחות או פרטים לוגיסטיים.",
  "landing.filter_review.features.event_forms.title": "טפסי אירועים",
  "landing.filter_review.features.guest_lists.summary": "רשומות מנוהלות על ידי מארגן עבור משקי בית, מוזמנים, פרטי קשר וסטטוס נוכחות.",
  "landing.filter_review.features.guest_lists.title": "רשימות אורחים",
  "landing.filter_review.features.invitation_websites.summary": "דפי אירועים פרטיים המציגים פרטי הזמנה, לוחות זמנים, מידע על נסיעות ופעולות אורח.",
  "landing.filter_review.features.invitation_websites.title": "אתרי הזמנות",
  "landing.filter_review.features.planner_portal.summary": "סביבת עבודה מאומתת למתכננים ולמארגנים המנהלים אירוע.",
  "landing.filter_review.features.planner_portal.title": "פורטל המתכנן",
  "landing.filter_review.features.registry.summary": "רישום אירועים או תיאום תרומות כאשר מאפשרים זאת על ידי המארגן.",
  "landing.filter_review.features.registry.title": "רשימת מתנות",
  "landing.filter_review.features.rsvp_management.summary": "כלים לאיסוף תגובות נוכחות מאורחים מוזמנים.",
  "landing.filter_review.features.rsvp_management.title": "ניהול RSVP",
  "landing.filter_review.features.seating_charts.summary": "כלי תכנון להקצאת אורחים לשולחנות או פינות ישיבה.",
  "landing.filter_review.features.seating_charts.title": "טבלאות ישיבה",
  "landing.filter_review.features.sms_notifications.summary": "תזכורות ועדכונים לאירועים אופציונליים שנשלחו למשתתפים המוזמנים.",
  "landing.filter_review.features.sms_notifications.title": "הודעות SMS",
  "landing.filter_review.features.timeline.summary": "לוחות זמנים של אירועים ואירועים עבור מארגנים, אורחים וספקים בהתאם להרשאותיהם.",
  "landing.filter_review.features.timeline.title": "ציר הזמן של האירוע",
  "landing.filter_review.features.vendor_portal.summary": "גישת ספקים בהיקף של לוחות זמנים, מטלות, הערות ופרטים תפעוליים הרלוונטיים לעבודת הספק.",
  "landing.filter_review.features.vendor_portal.title": "פורטל ספקים",
  "landing.filter_review.features.whatsapp_notifications.summary": "עדכוני אירועים אופציונליים מבוססי WhatsApp כאשר הם מופעלים ומותרים.",
  "landing.filter_review.features.whatsapp_notifications.title": "התראות WhatsApp",
  "landing.filter_review.hero.badge": "תיעוד ציבורי",
  "landing.filter_review.hero.last_updated_label": "עודכן לאחרונה",
  "landing.filter_review.hero.print_label": "הדפס או שמור",
  "landing.filter_review.hero.subtitle": "תיעוד טכני עבור ספקי סינון אינטרנט הבודקים את פלטפורמת Tov+.",
  "landing.filter_review.hero.title": "מרכז סקירת סינון אינטרנט",
  "landing.filter_review.hero.version_label": "גרסת תיעוד",
  "landing.filter_review.metadata.description": "תיעוד טכני עבור ספקי סינון אינטרנט הבודקים את פלטפורמת Tov+.",
  "landing.filter_review.metadata.title": "סקירת סינון אינטרנט | Tov+",
  "landing.filter_review.moderation.body": "הפלטפורמה מיועדת אך ורק לניהול אירועים לגיטימי. התעללות אסורה. תוכן לא חוקי עשוי להיות מוסר, תוכן מדווח עשוי להיבדק, וחשבונות המפרים את מדיניות הפלטפורמה עשויים להיות מושעים. טוב+ לא טוענת שכל העלאה נבדקת ידנית לפני הפרסום.",
  "landing.filter_review.navigation.label": "קטעי סקירת מסננים באינטרנט",
  "landing.filter_review.not_intended.adult": "אתר אינטרנט למבוגרים",
  "landing.filter_review.not_intended.dating": "פלטפורמת היכרויות",
  "landing.filter_review.not_intended.entertainment": "פלטפורמת בידורית",
  "landing.filter_review.not_intended.forum": "פורום דיונים",
  "landing.filter_review.not_intended.public_sharing": "אתר אינטרנט לשיתוף תוכן ציבורי",
  "landing.filter_review.not_intended.social_network": "רשת חברתית",
  "landing.filter_review.organizer_capabilities.digital_invitations": "צור הזמנות דיגיטליות",
  "landing.filter_review.organizer_capabilities.forms": "איסוף טפסי אירועים",
  "landing.filter_review.organizer_capabilities.guest_lists": "נהל רשימות אורחים",
  "landing.filter_review.organizer_capabilities.logistics": "תיאום לוגיסטיקת אירועים",
  "landing.filter_review.organizer_capabilities.reminders": "שלח תזכורות",
  "landing.filter_review.organizer_capabilities.rsvps": "אספו תשובות",
  "landing.filter_review.organizer_capabilities.seating": "הקצאת מקומות ישיבה",
  "landing.filter_review.organizer_capabilities.vendors": "ניהול ספקים",
  "landing.filter_review.privacy_statements.event_scoped_guest_info": "מידע אורח אינו גלוי מחוץ להקשר של אירוע או אירוע.",
  "landing.filter_review.privacy_statements.guest_information_private": "פרטי האורחים הם פרטיים.",
  "landing.filter_review.privacy_statements.no_boards": "אין לוחות דיונים ציבוריים.",
  "landing.filter_review.privacy_statements.no_public_galleries": "לא קיימות גלריות משתמשים ציבוריות.",
  "landing.filter_review.privacy_statements.private_event_pages": "אתרי הזמנות הם דפי אירועים פרטיים.",
  "landing.filter_review.privacy.body": "מידע על אורחים ואירועים מוגבל לאירוע וגלוי רק למשתמשים מורשים, אורחים מוזמנים, ספקים או מפעילי מערכת עם צורך תפעולי לגיטימי.",
  "landing.filter_review.privacy.policy_link": "קרא את מדיניות הפרטיות של טוב+",
  "landing.filter_review.public_areas.about": "אודות",
  "landing.filter_review.public_areas.help": "מרכז העזרה",
  "landing.filter_review.public_areas.landing": "דף נחיתה",
  "landing.filter_review.public_areas.pricing": "תמחור",
  "landing.filter_review.public_areas.privacy": "מדיניות פרטיות",
  "landing.filter_review.public_areas.shared_invitations": "דפי הזמנות משותפים",
  "landing.filter_review.public_areas.terms": "תנאים",
  "landing.filter_review.screenshot_targets.dashboard": "לוח בקרה",
  "landing.filter_review.screenshot_targets.forms": "טפסים",
  "landing.filter_review.screenshot_targets.guest_management": "ניהול אורחים",
  "landing.filter_review.screenshot_targets.invitation": "אתר הזמנה",
  "landing.filter_review.screenshot_targets.landing": "דף נחיתה",
  "landing.filter_review.screenshot_targets.rsvp": "עמוד RSVP",
  "landing.filter_review.screenshot_targets.seating": "טבלת ישיבה",
  "landing.filter_review.screenshot_targets.settings": "הגדרות",
  "landing.filter_review.screenshot_targets.vendor_portal": "פורטל ספקים",
  "landing.filter_review.screenshots.body": "צילומי מסך של מוצרים אמיתיים זמינים לסינון סוקרים כחלק מחשבון הדגמה או חבילת ביקורת.",
  "landing.filter_review.screenshots.note": "דף זה אינו משתמש בדוגמיות שיווקיות. כאשר מסופקים צילומי מסך, הם צריכים להראות מצבי יישום בפועל מסביבת הייצור או הסקירה.",
  "landing.filter_review.sections.about": "על Tov+",
  "landing.filter_review.sections.authentication": "אימות",
  "landing.filter_review.sections.contact": "פרטי קשר",
  "landing.filter_review.sections.content_policy": "מדיניות תוכן",
  "landing.filter_review.sections.demo": "גישה להדגמה",
  "landing.filter_review.sections.faq": "שאלות נפוצות",
  "landing.filter_review.sections.features": "תכונות הפלטפורמה",
  "landing.filter_review.sections.moderation": "פיקוח",
  "landing.filter_review.sections.privacy": "פרטיות",
  "landing.filter_review.sections.screenshots": "צילומי מסך",
  "landing.filter_review.sections.technical": "מידע טכני",
  "landing.filter_review.sections.third_parties": "שירותי צד שלישי",
  "landing.filter_review.sections.uploads": "תוכן שנוצר על ידי משתמשים",
  "landing.filter_review.sections.visibility": "נראות ציבורית",
  "landing.filter_review.sections.whitelisting": "בקשת אישור ברשימת ההיתרים",
  "landing.filter_review.table_labels.domain": "דומיין",
  "landing.filter_review.table_labels.essential": "חיוני",
  "landing.filter_review.table_labels.pdf": "PDF",
  "landing.filter_review.table_labels.purpose": "מטרה",
  "landing.filter_review.table_labels.service": "שירות",
  "landing.filter_review.technical.body": "הרשימה שלהלן נוצרת מתצורת אתר ציבורי משותף במידת האפשר ומוסיפה עם דומיינים של ייצור API, admin, בזמן אמת ותווים כלליים לאורחים המשמשים את הפלטפורמה.",
  "landing.filter_review.technical.domains_label": "ייצור דומיינים לרשימת היתרים",
  "landing.filter_review.technical.json_label": "הורד מידע טכני בתור JSON",
  "landing.filter_review.third_parties.email.purpose": "הזמנה עסקית, תזכורת ומשלוח דוא\"ל בחשבון.",
  "landing.filter_review.third_parties.essential_for_billing": "רק לחיוב",
  "landing.filter_review.third_parties.essential_for_notifications": "רק להודעות",
  "landing.filter_review.third_parties.essential_no": "לא",
  "landing.filter_review.third_parties.essential_operational": "מבצעי",
  "landing.filter_review.third_parties.essential_when_enabled": "רק כאשר מופעל",
  "landing.filter_review.third_parties.essential_yes": "כן",
  "landing.filter_review.third_parties.ga4.purpose": "ניתוח מוצר למדידת שימוש מצטבר.",
  "landing.filter_review.third_parties.keycloak.purpose": "ספק אימות וזהות.",
  "landing.filter_review.third_parties.maps.purpose": "תצוגת מפה או חיפוש מיקום שבו מופעלות תכונות מיקום האירוע.",
  "landing.filter_review.third_parties.messaging.purpose": "משלוח הודעות SMS ו-WhatsApp אופציונלי.",
  "landing.filter_review.third_parties.payments.purpose": "עיבוד מנוי, חשבונית וחיוב כאשר נעשה שימוש בתוכניות בתשלום.",
  "landing.filter_review.third_parties.railway.purpose": "תשתית אחסון ושירות של אפליקציות.",
  "landing.filter_review.third_parties.sentry.purpose": "ניטור שגיאות, אבחון וצפייה תפעולית.",
  "landing.filter_review.upload_types.documents": "מסמכי האירוע",
  "landing.filter_review.upload_types.event_images": "תמונות אירועים",
  "landing.filter_review.upload_types.invitation_designs": "עיצובי הזמנות",
  "landing.filter_review.upload_types.logos": "לוגואים",
  "landing.filter_review.upload_types.pdfs": "קובצי PDF",
  "landing.filter_review.uploads.access": "התוכן שהועלה שייך לבעל האירוע. זה לא ניתן לחיפוש ציבורי והוא נגיש רק למשתמשים מורשים או אורחים מוזמנים על פי הרשאות האירוע.",
  "landing.filter_review.uploads.body": "משתמשים עם גישה למארגן או למרחב עבודה מורשה עשויים להעלות קבצים הדרושים לאירוע.",
  "landing.filter_review.visibility.body": "טוב+ אינה פלטפורמה חברתית ציבורית. תוכן האירועים הוא פרטי, פרופילי משתמשים אינם ניתנים לגלישה ציבורית, ואירועים אינם מתווספים כספרייה ציבורית.",
  "landing.filter_review.visibility.shared_links": "קישורי הזמנה נועדו להיות משותפים על ידי מארגן האירוע. ייתכן שחלק מהדפי הזמנה יהיו נגישים לכל מי שיש לו את הקישור, אבל הקליעה או הדומיין לבדו אינם מעניקים גישה לנתוני לוח המחוונים הפרטיים.",
  "landing.filter_review.whitelisting.action": "צור קשר עם Tov+ כדי לבקש תמיכה ברשימה הלבנה או גישת הדגמה",
  "landing.filter_review.whitelisting.body": "Tov+ מברכת על סקירה של ספקי סינון אינטרנט ויכולה לספק פרטים טכניים נוספים, צילומי מסך או גישה להדגמה בעת הצורך.",
  "landing.footer.acceptable_use": "שימוש מקובל",
  "landing.footer.cookie_policy": "מדיניות קובצי Cookie",
  "landing.footer.description": "תכנון מבוסס אירוע לצוותים שמפעילים חוויות מרובות אירועים יפות מתוך סביבת עבודה מחוברת אחת.",
  "landing.footer.documentation": "תיעוד",
  "landing.footer.guest_dashboard": "דשבורד אורחים",
  "landing.footer.legal": "משפטי",
  "landing.footer.planner_dashboard": "דשבורד מתכננים",
  "landing.footer.privacy_policy": "מדיניות פרטיות",
  "landing.footer.product": "מוצר",
  "landing.footer.terms_of_service": "תנאי שימוש",
  "landing.footer.vendor_dashboard": "דשבורד ספקים",
  "landing.hero.description": "Tov+ עוזרת למתכננים ולזוגות להפעיל אירועים אלגנטיים מרובי אירועים עם פלטפורמה מחוברת אחת לתכנון, אורחים ותקשורת.",
  "landing.hero.invitation_date": "18 ביוני 2027",
  "landing.hero.invitation_detail": "מבקשים את הכבוד בנוכחותכם",
  "landing.hero.invitation_kicker": "יחד עם משפחותיהם",
  "landing.hero.invitation_name_one": "מאיה",
  "landing.hero.invitation_name_two": "נועם",
  "landing.hero.invitation_venue": "בית הגן",
  "landing.hero.lede": "הפלטפורמה הכוללת למתכננים ולזוגות לתכנן, לנהל ולשתף כל רגע באלגנטיות.",
  "landing.hero.preview_label": "תצוגה מקדימה של הזמנה",
  "landing.hero.title": "אירועים יפים, מתוכננים בדיוק",
  "landing.hero.title_line_one": "אירועים יפים,",
  "landing.hero.title_line_two": "מתוכננים בדיוק.",
  "landing.legal.acceptable_use_description": "קראו את מדיניות השימוש המקובל של Tov+.",
  "landing.legal.acceptable_use_title": "מדיניות שימוש מקובל",
  "landing.legal.cookie_policy_description": "קראו את מדיניות קובצי ה-Cookie של Tov+.",
  "landing.legal.cookie_policy_title": "מדיניות קובצי Cookie",
  "landing.legal.loading_document": "המסמך נטען.",
  "landing.legal.privacy_policy_description": "קראו את מדיניות הפרטיות של Tov+.",
  "landing.legal.privacy_policy_title": "מדיניות פרטיות",
  "landing.legal.terms_description": "קראו את תנאי השימוש של Tov+.",
  "landing.legal.terms_title": "תנאי שימוש",
  "landing.navigation.features": "יכולות",
  "landing.navigation.get_started": "להתחיל",
  "landing.navigation.language_label": "שפה",
  "landing.navigation.pricing": "מחירים",
  "landing.navigation.primary_label": "ניווט ראשי",
  "landing.navigation.vendor_access": "גישה לספקים",
  "landing.planner_checklist.centralize": "רכזו פרטי אירועים, הקשר ספקים ונראות לאורחים במקום אחד.",
  "landing.planner_checklist.collaborate": "שתפו פעולה עם הצוות והלקוחות בלי ליצור מעקפים מנותקים.",
  "landing.planner_checklist.guest_experience": "ספקו חוויית אורחים מלוטשת מההזמנה הראשונה ועד המעקב האחרון.",
  "landing.planner_checklist.modules": "השתמשו במודולים מבוססי אירוע כדי שכל אירוע יקבל את הכלים וההרשאות הנכונים.",
  "landing.pricing.free_cadence": "לאירוע אחד",
  "landing.pricing.free_description": "לזוגות שמתחילים עם אתר אירוע פשוט לאורחים.",
  "landing.pricing.free_feature_guest_site": "אתר אורחים ופרטי אירוע בסיסיים",
  "landing.pricing.free_feature_rsvp": "איסוף RSVP פשוט",
  "landing.pricing.free_feature_updates": "עדכונים בסיסיים לאורחים",
  "landing.pricing.free_name": "חינם",
  "landing.pricing.free_price": "$0",
  "landing.pricing.planner_demos": "דמואים למתכננים זמינים",
  "landing.pricing.pro_cadence": "לאירוע",
  "landing.pricing.pro_description": "למתכננים ולזוגות שמנהלים חוויה מלאה מרובת אירועים.",
  "landing.pricing.pro_feature_communications": "הודעות ותזכורות לאורחים",
  "landing.pricing.pro_feature_multi_event": "לוחות זמנים וצירי זמן מרובי אירועים",
  "landing.pricing.pro_feature_vendor_access": "גישה ממוקדת לספקים",
  "landing.pricing.pro_name": "פרו",
  "landing.pricing.pro_price": "$29",
  "landing.pricing.scale": "גדילה לאירועים מרובי אירועים",
  "landing.pricing.start_free": "התחלה חינם לזוגות",
  "landing.pricing.studio_cadence": "לחודש",
  "landing.pricing.studio_description": "לסטודיו לתכנון שמנהל כמה לקוחות, צוותים ורשת ספקים.",
  "landing.pricing.studio_feature_support": "ליווי ותמיכה בעדיפות גבוהה",
  "landing.pricing.studio_feature_team": "סביבת עבודה לצוות ותפעול לקוחות",
  "landing.pricing.studio_feature_templates": "תבניות אירוע לשימוש חוזר",
  "landing.pricing.studio_name": "סטודיו",
  "landing.pricing.studio_price": "$99",
  "landing.sections.features_description": "תכננו את האירוע, פרסמו את חוויית האורחים, תאמו ספקים ושמרו שכל משתתף יראה את התצוגה הנכונה.",
  "landing.sections.features_eyebrow": "מה Tov+ תומכת",
  "landing.sections.features_title": "סביבת עבודה אחת לכל האירוע",
  "landing.sections.pricing_description": "התחילו פשוט, ואז פתחו את העומק התפעולי שנדרש למתכננים, ספקים ואירועים מרובי אירועים.",
  "landing.sections.pricing_eyebrow": "מחירים",
  "landing.sections.pricing_title": "מסלולים לזוגות ולצוותי תכנון",
  "landing.trust.built_for_planners": "נבנה למתכננים",
  "landing.trust.free_for_couples": "חינם לזוגות",
  "landing.trust.no_credit_card_required": "אין צורך בכרטיס אשראי"
}
